import { UserBuilder, defaultHashUserId } from '@nab/nab-x-sdk-browser';
// eslint-disable-next-line import/no-named-default
import { default as uniqid } from 'uniqid';
let shellUser;
const defaultUserConfig = {
    id: uniqid(),
    hashUserId: defaultHashUserId,
    authenticated: false
};
export const buildUser = (userConfig, app, analyticsMgr, dataSecurityMgr, flagMgr) => {
    const config = {
        ...defaultUserConfig,
        ...userConfig
    };
    const userBuilder = new UserBuilder();
    shellUser = userBuilder
        .id(config.id, config.hashUserId(config.id))
        .app(app)
        .authenticated(config.authenticated)
        .details(config.details)
        .context(config.context)
        .userOrg(config.org)
        .userType(config.type)
        .actAs(config.as)
        .analyticsManager(analyticsMgr)
        .dataSecurityManager(dataSecurityMgr)
        .flagMgr(flagMgr)
        .build();
    return shellUser;
};
export const getUserForShell = () => shellUser;
/**
 * Creates a User service which is pre-configured for a specific app.
 * - Ensures methods can be pre-configured so mini-apps don't need to supply their own appId or instanceId as method params
 * - Ensures shared service is encapsulated so a rogue mini-app can't mutate or break it for all other apps
 * - Enables support for sessionId/instanceId correlation for analytics or any future services
 *
 * The pattern here is similar to that of action functions by where we create a tailored set of functions for each app
 * pre-configured to work with the app's appId and instanceId
 */
export function getUserForApp(appDetails) {
    return shellUser.forkForApp(appDetails);
}
export const resetUserRegistry = () => {
    shellUser = undefined;
};
//# sourceMappingURL=core.js.map